import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardBody } from '@vnetwork/ui/primitives';

/** Card shell for a Capacities dashboard chart/section — title + optional description. */
export function CapacitySectionCard({
  title,
  description,
  actions,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card flat style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader actions={actions}>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardBody style={{ flex: 1 }}>{children}</CardBody>
    </Card>
  );
}
